import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-167e6e22"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content" }

import { ref, toRefs, withDefaults } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialButton',
  props: {
    url: { default: "" },
    title: null,
    size: { default: "2rem" },
    radius: { default: "50%" },
    isHover: { type: Boolean, default: false },
    color: { default: "red" },
    background: { default: "#fff" },
    backgroundHover: { default: "#3E3E3E" }
  },
  emits: ["tap"],
  setup(__props: any, { emit }) {

const props = __props as { url: string, title?: string, size: string, radius: string, isHover: boolean, color: string, background: string, backgroundHover: string };

_useCssVars(_ctx => ({
  "748d444e": (_unref(size)),
  "150c1106": (_unref(background)),
  "3aa9d46a": (_unref(radius)),
  "1ed926ea": (_unref(color)),
  "433e7bd6": (_unref(backgroundHover))
}))





const { size, radius, isHover, color, background, backgroundHover } =
  toRefs(props);

const tap = () => {
  emit("tap");
};

const show = ref("current");

const toggleShow = (type: string) => {
  show.value = !isHover.value ? "current" : type;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "social-button",
    title: __props.title,
    onClick: tap,
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (toggleShow('hover'))),
    onMouseout: _cache[1] || (_cache[1] = ($event: any) => (toggleShow('current')))
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, show.value === 'current']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "hover")
    ], 512), [
      [_vShow, show.value === 'hover']
    ])
  ], 40, _hoisted_1))
}
}

})